import { render, staticRenderFns } from "./NewsView.vue?vue&type=template&id=ff53b5ec&scoped=true"
import script from "./NewsView.vue?vue&type=script&lang=js"
export * from "./NewsView.vue?vue&type=script&lang=js"
import style0 from "./NewsView.vue?vue&type=style&index=0&id=ff53b5ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff53b5ec",
  null
  
)

export default component.exports